<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid"
            class="properties-dictionary-dialog"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' PROPERTY'">

    <form #mapForm="ngForm" autocomplete="off">
        <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="data.selectedItem.description" name="description" maxlength="255">
        </mat-form-field>

        <mat-checkbox [(ngModel)]="data.selectedItem.dialable" [ngModelOptions]="{standalone: true}" color="primary">Dialable</mat-checkbox>

        <mat-checkbox [(ngModel)]="data.selectedItem.primary" [ngModelOptions]="{standalone: true}" color="primary">Displayed in users table</mat-checkbox>

        <span>Combined attribute</span><mat-slide-toggle [(ngModel)]="data.selectedItem.isCombined" [ngModelOptions]="{standalone: true}" color="primary" [disabled]="data.selectedItem.isCombined && data.isEditMode"></mat-slide-toggle>

        <div *ngIf="data.selectedItem.isCombined" class="combined-attribute">
            <mat-checkbox [(ngModel)]="data.selectedItem.normalizeCombinedProperty" [ngModelOptions]="{standalone: true}" color="primary">Use values after normalization</mat-checkbox>

            <mat-form-field style="padding-top: 10px">
                <mat-label>Property 1</mat-label>
                <mat-select required [(ngModel)]="data.selectedItem.combinationPropertyId1" name="attribute-1">
                    <mat-option *ngFor="let attribute of data.attributes" [value]="attribute.id">
                        {{attribute.name}}
                    </mat-option>
                </mat-select>
                <mat-error>
                    Combination Property Id 1 is <strong>required</strong>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Property 2</mat-label>
                <mat-select required [(ngModel)]="data.selectedItem.combinationPropertyId2" name="attribute-2">
                    <mat-option *ngFor="let item of data.attributes" [value]="item.id">
                        {{item.name}}
                    </mat-option>
                </mat-select>
                <mat-error>
                    Combination Property Id 2 is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Delimiter</mat-label>
                <input matInput required [(ngModel)]="data.selectedItem.combinationDelimiter" name="combinationDelimiter">
                <mat-error>
                    Delimiter is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</arm-dialog>
